import { z } from 'zod';

/** Itens por página nas listagens pesadas (estoque, contas, contratos, multas). */
export const POR_PAGINA = 20;

/**
 * Paginação opcional: sem `pagina`, a rota responde a lista simples de antes (seletores,
 * busca global); com `pagina`, responde `Pagina<T>` — é o que as telas de lista usam.
 */
export const paginacaoSchema = z.object({
  pagina: z.coerce.number().int().min(1).max(10_000).optional(),
  porPagina: z.coerce.number().int().min(1).max(100).default(POR_PAGINA),
});
export type Paginacao = z.infer<typeof paginacaoSchema>;

export interface Pagina<T> {
  itens: T[];
  pagina: number;
  porPagina: number;
  total: number;
  temMais: boolean;
}

/** skip/take do Prisma para a página pedida. */
export function janelaDaPagina(p: { pagina: number; porPagina: number }) {
  return { skip: (p.pagina - 1) * p.porPagina, take: p.porPagina };
}

export function montarPagina<T>(
  itens: T[],
  total: number,
  p: { pagina: number; porPagina: number },
): Pagina<T> {
  return {
    itens,
    pagina: p.pagina,
    porPagina: p.porPagina,
    total,
    temMais: p.pagina * p.porPagina < total,
  };
}
